import styled from 'styled-components';

export const Container = styled.div<{ active: boolean }>`
  width: 240px;

  .members-select__control {
    min-height: 38px;
    cursor: pointer;
    flex-wrap: nowrap;
    border-color: ${(props) => (props.active ? props.theme.$primary : props.theme.$gray300)};
    box-shadow: none;
  }

  .members-select__control:hover {
    border-color: ${(props) => (props.active ? props.theme.$primary : props.theme.$gray400)};
  }

  .members-select__value-container {
    min-width: 0;
    padding-left: 0.25rem;
  }

  .members-select__placeholder {
    color: ${(props) => props.theme.$dark};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .members-select__indicator-separator {
    display: none;
  }

  .members-select__menu {
    width: max-content;
    min-width: 100%;
    z-index: 1050;
  }

  .members-select__option {
    cursor: pointer;
    color: ${(props) => props.theme.$dark};
    background: ${(props) => props.theme.$white};
  }

  .members-select__option--is-focused {
    background: ${(props) => props.theme.$gray200};
  }

  .members-select__option:first-child {
    border-bottom: 1px solid ${(props) => props.theme.$gray300};
    padding-bottom: 0.75rem;
    margin-bottom: 0.25rem;
  }

  .members-label {
    color: ${(props) => props.theme.$gray600};
    white-space: nowrap;
  }

  .material-icons {
    font-size: 20px;
  }

  .member-checkbox {
    flex: none;
    width: 16px;
    height: 16px;
    margin-right: 0.75rem;
    pointer-events: none;
  }
`;
